import GoogleMap from 'google-map-react';
import React, { useContext, useEffect } from 'react';
import GoogleMapProvider, { GoogleMapContext } from '../../cnr/contexts/GoogleMapContext';
import { LocationsContext } from '../../cnr/contexts/LocationContext';
import { copyDirect } from '../../common_web/copy';
import { MapWindow, mapMarkers } from './MapMarkers';

// https://developers.google.com/maps/documentation/javascript/controls

const GoogleMapAppUsers = (props) => {

  const locationsContext = useContext(LocationsContext);
  const { locations_state } = locationsContext ?? {}
  const { appUserUid, locations, appLocation, appLocationTracking } = locations_state ?? {}
  const { showDemo, demoCoordinates } = appLocationTracking ?? {}

  // googleMapContext
  const googleMapContext = useContext(GoogleMapContext);
  const { googleMap_state, googleMap_handlers } = googleMapContext ?? {}
  const { apiKey, appUserMarkers, demoMarkers, currentInfoWindow } = googleMap_state ?? {}

  const cood = appLocation ? {
    center: {
      lat: parseFloat(appLocation.latitude),
      lng: parseFloat(appLocation.longitude),
    },
    zoom: 15
  } : null


  useEffect(() => {
    if (locations) {
      googleMap_handlers.handleGetMarkers_appUsers(locations, appUserUid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [locations]);

  useEffect(() => {
    if (showDemo && demoCoordinates) {
      googleMap_handlers.handleGetMarkers_demo(demoCoordinates)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const handleApiLoaded = (map, maps) => googleMap_handlers.handleSet_map(map, maps, true)

  const handleMapClick = (a) => {
    const coords = { lat: a.lat, lng: a.lng }
    copyDirect(coords, ['lat', 'lng'])
    googleMap_handlers.handleClose_infoWindow()
  }

  const handleChildClick = (a, b, c) => googleMap_handlers.handleOpen_infoWindow(b)
  const closeInfoWindow = () => googleMap_handlers.handleClose_infoWindow()

  const content = () => {
    if (cood) {
      return <div className={'map-simple'}>
        <GoogleMap
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={cood.center}
          defaultZoom={cood.zoom}
          yesIWantToUseGoogleMapApiInternals
          onClick={handleMapClick}
          onChildClick={handleChildClick}
          onGoogleApiLoaded={({ map, maps }) => {
            handleApiLoaded(map, maps)
          }}
        // onChildMouseEnter={handleMapEnter} 
        >
          {appUserMarkers && mapMarkers(appUserMarkers, 'au')}
          {demoMarkers && mapMarkers(demoMarkers, 'def')}

          {currentInfoWindow && <MapWindow
            lat={currentInfoWindow.lat}
            lng={currentInfoWindow.lng}
            marker={currentInfoWindow.marker}
            oc={closeInfoWindow}
          ></MapWindow>}

        </GoogleMap>
      </div>
    } else {
      return <div>{'No Coordinates'}</div>
    }
  }

  return content()
}

const GoogleMapAppUsersWithProvider = (props) => {
  return <GoogleMapProvider {...props}>
    <GoogleMapAppUsers {...props} />
  </GoogleMapProvider>
}

export default GoogleMapAppUsersWithProvider